import Link from 'next/link'
import { ReactNode } from 'react'

import ChevronRight from '../svg/ChevronRight'

interface Props {
  label: string
  href?: string
  onClick?: VoidFunction
  btnType?: 'button' | 'submit'
}

type ContainerProps = Omit<Props, 'label'> & { children: ReactNode }

const Container = ({ href, onClick, btnType, children }: ContainerProps) =>
  href ? (
    <Link
      href={href}
      className="text-[#6fbc1d] group-hover:text-white leading-8 relative w-full h-8 text-center transition-all duration-300 flex items-center"
    >
      {children}
    </Link>
  ) : (
    <button
      type={btnType}
      onClick={onClick}
      className="text-[#6fbc1d] group-hover:text-white leading-8 relative w-full h-8 text-center transition-all duration-300 flex items-center"
    >
      {children}
    </button>
  )

const ArrowButton = ({ label, href, onClick, btnType = 'button' }: Props) => (
  <Container href={href} onClick={onClick} btnType={btnType}>
    <span className="bg-[#6fbc1d] w-8 h-8 relative inline-flex items-center justify-center">
      <span className="bg-white top-1/2 -translate-y-1/2 absolute w-0 h-0.5 opacity-0 group-hover:w-4 group-hover:opacity-100 transition-all duration-300" />
      <ChevronRight className="fill-white visible opacity-100 h-6 w-6 group-hover:ml-3 transition-all duration-300" />
    </span>
    <span className="flex-1 text-center">{label}</span>
  </Container>
)

export default ArrowButton
